<template>
  <div v-loading='loading' class='gPageBorder'>

    <el-row>
      <el-col :span='4'>
        <el-button class='gSgLeftBtn' type="primary" @click="upload" icon="upload">{{$t('app_upload')}}</el-button>
      </el-col>
      <el-col :span='12'>
        <div class='gSpDiv'></div>
      </el-col>
      <el-col :span='4'>
        <div class='gCtrl'>
          <el-select @change='selectChange' style='' v-model="fType" clearable :placeholder="$t('app_type')">
            <el-option
              v-for="item in $firmwareTypes"
              :key="item.vl"
              :label="item.label"
              :value="item.vl">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='gSideCtrl'>
          <el-input
            icon='search'
            :on-icon-click='search'
              :placeholder="$t('app_name')"
            v-model="qName"
            @keyup.enter.native="search">
          </el-input> 
        </div>
      </el-col>
    </el-row>


     <el-table
      :data="tableData"
      border
      class='gTopMg'
      style="width: 100%;"
      ref="arrdata">
        <el-table-column
        prop="firmwareName"
        :label="$t('lin_global.name')">
        </el-table-column>
        <el-table-column
        prop="version"
        :label="$t('lin_global.version')"
        width="120">
        </el-table-column>
        <!--<el-table-column
        prop="status"
        label="状态"
        width="150"
        :formatter="formatStatus">
        </el-table-column>-->
       <el-table-column
         :label="$t('lin_global.status')"
         width="">
         <template slot-scope="scope">

           <span v-if="scope.row.status == 0" style="color: #8492A6;">{{$t('lin_global.waitOne')}}</span>
           <span v-if="scope.row.status == 1" style="color: #F7BA2A;">{{$t('lin_global.waitTwo')}}</span>
           <span v-if="scope.row.status == 2" style="color:#13CE66;">{{$t('lin_global.verifyPass')}}</span>
           <span v-if="scope.row.status == 3" style="color: #FF4949;">{{$t('lin_global.verifyNotPass')}}</span>
           <span style='cursor:pointer;' v-popover:popover2 v-show="scope.row.status === 3">
             <i style='color:#58B7FF' class="el-icon-information"></i>
             <el-popover ref="popover2" placement="top" title="" width="" trigger="click" :content="scope.row.auditContent"></el-popover>
           </span>
         </template>
       </el-table-column>
        <el-table-column
        prop="type"
        :label="$t('terminal.details.animatType')"
        width="100">
        </el-table-column>
        <el-table-column
        prop="mechanismName"
        :label="$t('lin_global.label_areaid')">
        </el-table-column>
        <el-table-column
        prop="downloads"
        :label="$t('lin_global.downNumber')"
        width="">
        </el-table-column>
        <el-table-column
          align="right"
          header-align="center"
          :label="$t('lin_global.ope')" width="120">
        <template slot-scope="scope">

          <!-- <el-tooltip class="item" v-show='scope.row.status === 2' effect="dark" :content="$t('app_push')" placement="top">
            <el-button type='text' @click="toPush(scope.row)"><i class="fa fa-upload" style=""></i></el-button>
          </el-tooltip> -->

          <!-- <el-button v-show="scope.row.status === 0 || scope.row.status === 3" @click="editFw(scope.row)" type=text>{{$t('app_edit')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
            <el-button type='text' v-show="scope.row.status === 0 || scope.row.status === 3" @click="editFw(scope.row)"><i class="fa fa-pencil" style=""></i></el-button>
          </el-tooltip>
          
          <!-- <el-button v-show="scope.row.status === 0 || scope.row.status === 3" @click="submitFw(scope.row)" type=text>{{$t('app_smVerify')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
            <el-button type='text' v-show="scope.row.status === 0 || scope.row.status === 3" @click="submitFw(scope.row)"><i class="fa fa-external-link-square" style=""></i></el-button>
          </el-tooltip>

          <!-- <el-button @click="delFw(scope.row)" type=text>{{$t('app_del')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
            <el-button type='text' @click="delFw(scope.row)"><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
          </el-tooltip>

        </template>
        </el-table-column>
      </el-table>
      <div class='gPgDiv'>
      <el-pagination
        class='gPg'
        @size-change="pageSized"
        @current-change="handleCurrentChange"
        :current-page="index"
        :page-sizes="$gRows"
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        abc: '',
        mechanismId: window.localStorage['mechanismId'],
        loading: 0,
        fType:'',
        tableData:[],
        total: 0,
        qName:'',
        type: [{
              value: '',
              label: this.$t('lin_global.allType')
            }, {
              value: 'ota',
              label: 'OTA'
            }, {
              value: 'rom',
              label: 'ROM'
          }]
      }
    },
    computed: {
      index () {
        return this.$getWPage('firmwarePage')
      }
    },
    mounted(){ 
      // console.log(this.fTypes)
      this.getList()

    },
    methods:{
      toPush (row) {
        //console.log(row.id)
        this.$setWObj('pushList', {type: '4', data: row})
        this.$router.push({path: '/firmware/push'})
      },
      reset () {
        this.fType = ''
        this.qName = ''
        this.getList()
      },
      delFw(row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipAppEdit'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$deleteFirmware(row.id, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$message.success(res.message)
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        }, '')
      },
      editFw(row) {
        this.$setWObj('info', row)
        this.$router.push({path: 'firmwareManage/edit'})
      },
      submitFw(row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isSubmitToCheck'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$checkFirmware(row.id, '', '1', (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$message.success(res.message)
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        }, '')
      },
      search () {
        this.getList()
      },
      selectChange () {
        this.getList()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      submitRow:function(id){
        let token = localStorage.getItem('user');
        var params = {token:token,ota_rom_id:id,content:'',status:1};
        this.$confirm(this.$t('lin_global.qdtjsh'), this.$t('lin_btn.tips'), {
              confirmButtonText: this.$t('lin_btn.confirm'),
              cancelButtonText: this.$t('lin_btn.cancel'),
              type: 'warning'
            }).then(() => {
          axios.post(`${baseurl}/ota_rom/audit.do`,params).then(res=>{
            //console.log("提交审核返回参数")
            //console.log(res.data)
                  if (res.data.status == 200) {
                    this.$message.success(this.$t('lin_global.tjshcg'))
                    this.getData(1,'')
                  } else {
                    this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {

        })
      },
      editRow:function(id){
        this.$router.push({ path: '/romList/'+id+'/edit' })
      },
      deleteRow:function(id){
        var params = {ids:id}
        this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
              confirmButtonText: this.$t('lin_btn.confirm'),
              cancelButtonText: this.$t('lin_btn.cancel'),
              type: 'warning'
            }).then(() => {
              axios.post(`${baseurl}/firmwareInfo/delete.do`,params).then(res=>{
                if (res.data.status == 200) {
                  this.$message.success(this.$t('lin_global.delete_success'))
                  this.getData(1,'')
                } else {
                  this.$message.error(res.data.message)
                }
              })
            }).catch(() => {

        })
      },
      getList () {
        this.loading = 1
        var type = this.fType ? this.fType : ''
        var name = this.qName ? this.qName : ''
        var status = ''
        this.$getFirmwareList(this.$gRow, this.$getWPage('firmwarePage'), '', name, type, status, (res) => {
          console.log('res', res)
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      upload:function(){
        this.$router.push({path:'firmwareManage/upload'})
      },
      handleIconClick:function(){
      },
      handleSizeChange: function (val) {

      },
      handleCurrentChange: function (index) {
        this.$setWPage('firmwarePage', index)
        this.getList()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// manage.vue?72717f80